<template>
  <file-manager v-bind:settings="settings"></file-manager>
</template>

<script>
  const debug = process.env.NODE_ENV !== 'production';

  export default {
    name: 'AdminFileManager',
    computed: {
      settings() {
        return {
          // axios headers
          baseUrl: debug ? 'http://'+window.document.location.host+'/file-manager/' : `https://${window.document.location.host}/file-manager/`,   // overwrite base url Axios
          windowsConfig: 1,                           // overwrite config
          lang: 'ua',                                 // set language
        };
      },
    }
  }
</script>

<style scoped>

</style>